module.exports = __webpack_public_path__ + "media/images/immersive_assignment-4479b583dc1f8430bb425fb24c03252d.svg";